import { FileTypeEnum as e } from "../libs/types/dist/index6.mjs";
import "../enums/file-type-enum.mjs";
function a(o) {
  var n;
  const t = (n = o.split(".").pop()) == null ? void 0 : n.toLowerCase();
  if (!t) return e.Document;
  const i = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"], s = ["tiff", "heic", "raw"], r = ["mp4", "mov", "avi", "mkv", "webm"], c = ["mp3", "wav", "ogg", "aac", "flac"], u = ["ttf", "otf", "woff", "woff2"], f = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "csv"];
  return i.includes(t) ? e.Image : s.includes(t) ? e.ImageOther : r.includes(t) ? e.Video : c.includes(t) ? e.Audio : u.includes(t) ? e.Font : f.includes(t) ? e.Document : e.Document;
}
export {
  a as getFileTypeFromName
};
